import React from "react";
import { useNavigate } from 'react-router-dom';
import '../assets/styles/Project.scss';
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import {
    Grid, Paper,
    Stack, Tooltip,
    Typography
} from "@mui/material";
import Button from "@mui/material/Button";
import GitHubIcon from "@mui/icons-material/GitHub";
const gutterX = { xs: 2, sm: 3, md: 6, lg: 16 };
const sectionSx = {
    bgcolor: "#fff" ,//f9f9f9",
    py: 2,
    borderRadius: 3,
    px: 3,
    borderLeft: "4px solid #1f5185",
    borderRight: "4px solid #1f5185",
};
type BoldWordProps = {
    children: React.ReactNode;
};
const sparrowxVideo = "/sparrowx-flow.mp4";

export function BoldWord({ children }: BoldWordProps) {
    return (
        <Typography
            component="span"
            sx={{
                fontSize: { xs: "0.7rem", sm: "0.75rem", md: "1rem" },
                fontWeight: 700,
                color: "#1f5185",
                fontFamily: "calibri",
            }}
        >
            {children}
        </Typography>
    );
}

const techChipSx = {
    color: "#000",
    backgroundColor: "#1F51853D",
};
const techStack = [
    "k3", "Linkerd", "Java", "Springboot", "Embabel", "PostgreSQL", "CassandraDB",
    "Kafka", "Neo4j DB", "Qdrant", "Minio"
];

function Project() {

    const navigate = useNavigate();

    return(
        <Grid container>
            <Grid item xs={12} sx={{mt: 3, px: gutterX, mb: 2}} id="portfolio">
                <Typography  variant="h4"
                             sx={{
                                 fontFamily: "calibri",
                                 fontSize: '2rem',
                                 textAlign: "center",
                                 fontWeight: 400,
                                 color: "#1f5185 !important" }}>
                    Projects
                </Typography>
                <Box
                    display="flex"
                    justifyContent="center"
                    sx={{
                        width: "100%",
                        height: "3px",
                        background: "linear-gradient(90deg, #cfe9ff 0%, #205287B2 50%, #cfe9ff 100%)",
                        mb: 2,
                    }}
                />
                <Box sx={sectionSx}>

                    {/* Projects */}
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Paper elevation={0} sx={{ p: 2 }}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: { xs: "column", md: "row" },
                                        gap: 2,
                                    }}
                                >
                                    {/* Media */}
                                    <Tooltip
                                        title="Click to View Fullscreen"
                                        arrow
                                        //followCursor


                                        componentsProps={{
                                            tooltip: {
                                                sx: {
                                                    bgcolor: "rgba(0,0,0,0.85)",
                                                    fontSize: 13,
                                                },
                                            },
                                        }}
                                    >

                                        <Box
                                            sx={{
                                                maxHeight: 420,
                                                flex: 1,
                                                minHeight: { xs: 200, md: 220 },
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                overflow: "hidden",
                                                borderRadius: 1,
                                                aspectRatio: "1920 / 1080",
                                            }}
                                        >
                                            <Box
                                                component="a"
                                                href={sparrowxVideo}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                sx={{
                                                    display: "block",
                                                    width: "100%",
                                                    height: "100%",
                                                }}
                                            >
                                                <Box
                                                    component="video"
                                                    autoPlay
                                                    loop
                                                    muted
                                                    playsInline
                                                    sx={{
                                                        width: "100%",
                                                        height: "100%",
                                                        objectFit: "contain", // ← important for clarity
                                                        display: "block",
                                                    }}
                                                >
                                                    <source src={sparrowxVideo} type="video/mp4" />
                                                </Box>
                                            </Box>
                                        </Box>
                                    {/*<Box*/}
                                    {/*    sx={{*/}
                                    {/*        maxHeight: 420,*/}
                                    {/*        flex: 1,*/}
                                    {/*        minHeight: { xs: 200, md: 220 },*/}
                                    {/*        display: "flex",*/}
                                    {/*        alignItems: "center",*/}
                                    {/*        justifyContent: "center",*/}
                                    {/*        overflow: "hidden",*/}
                                    {/*        borderRadius: 1,*/}
                                    {/*        aspectRatio: "1920 / 1500", // ≈ 1.28*/}
                                    {/*    }}*/}
                                    {/*>*/}
                                    {/*    <Box*/}
                                    {/*        component="a"*/}
                                    {/*        href={sparrowxgif}*/}
                                    {/*        target="_blank"*/}
                                    {/*        rel="noopener noreferrer"*/}
                                    {/*        sx={{*/}
                                    {/*            display: "block",*/}
                                    {/*            width: "100%",*/}
                                    {/*            height: "100%",*/}
                                    {/*        }}*/}
                                    {/*    >*/}
                                    {/*        <Box*/}
                                    {/*            component="img"*/}
                                    {/*            src={sparrowxgif}*/}
                                    {/*            alt="SparrowX preview"*/}
                                    {/*            sx={{*/}
                                    {/*                width: "100%",*/}
                                    {/*                height: "100%",*/}
                                    {/*                objectFit: "fill",*/}
                                    {/*            }}*/}
                                    {/*        />*/}
                                    {/*    </Box>*/}
                                    {/*</Box>*/}
                                    </Tooltip>

                                    {/* Content */}
                                    <Box sx={{ flex: 1, display: "flex" }}>
                                        <Box>
                                            <Typography
                                                variant="body1"
                                                component="p"
                                                sx={{
                                                    color: "#7c7c7c",
                                                    //textAlign: "center",
                                                    fontSize: { xs: "0.5rem", sm: "0.7rem", md: "0.9rem" },
                                                    fontFamily:"system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
                                                    lineHeight: 1.3,
                                                }}
                                            >
                                                Exploring distributed systems alongside Embabel in this AI era led me to the realization
                                                that AI orchestration is rising as LLM performance gains plateau. Inspired by Embabel,
                                                a disciplined evolution amongst LangGraph and OpenClaw, I’ve been building Sparrow-X,
                                                which prioritizes instructional rigor and architectural clarity over prompt-driven
                                                improvisation.
                                                <br/>
                                                <BoldWord>The Project is still under construction</BoldWord>
                                            </Typography>

                                            <Typography
                                                variant="body1"
                                                component="p"
                                                sx={{
                                                    color: "#7c7c7c",
                                                    //textAlign: "center",
                                                    fontSize: { xs: "0.4rem", sm: "0.6rem", md: "0.8rem" },
                                                    fontFamily:"system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
                                                }}
                                            >
                                                <BoldWord>Agentic & LLM Execution:</BoldWord> Designed and operated an Embabel-based agentic execution layer orchestrating
                                                retrieval, planning, reasoning, and tool invocation across distributed services, with measured latency budgets,
                                                deterministic execution graphs, and observability hooks to evaluate goal-driven LLM workflows under production constraints.
                                                <br/>
                                                <BoldWord>• Scale & Performance</BoldWord>: Should sustain ~5,000 rps with p95 sub-200 ms latency across read/write-heavy and fan-out workloads.
                                                <br/>
                                                <BoldWord>• Architecture</BoldWord>: Production microservices platform using Docker, API Gateway, service-to-service mTLS (Linkerd), and an event-driven bus (Kafka) with backpressure and retries.
                                                <br/>
                                                <BoldWord>• Reliability & Resilience</BoldWord>: Built-in fault isolation using Resilience4j (timeouts, retries, circuit breakers, rate limiting) to maintain SLOs under partial failures.
                                                <br/>
                                                <BoldWord>• Observability & Operations</BoldWord>: Full-stack observability with Prometheus, Tempo, and Loki, enabling latency decomposition, saturation analysis, and fast incident triage.
                                                <br/>

                                            </Typography>

                                            <Typography
                                                variant="subtitle1"
                                                fontWeight="bold"
                                                sx={{ mt: 1 }}
                                            >
                                                Tech Stack:
                                            </Typography>

                                            <Stack direction="row" flexWrap="wrap" gap={1} sx={{ mt: 0.5 }}>
                                                {techStack.map((tech) => (
                                                    <Chip
                                                        key={tech}
                                                        size="small"
                                                        label={tech}
                                                        sx={techChipSx}
                                                        variant="outlined"
                                                    />
                                                ))}
                                            </Stack>

                                            <Button
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                variant="outlined"
                                                href="https://github.com/hashedgrey/Sparrow-x"
                                                startIcon={<GitHubIcon />}
                                                sx={{
                                                    mt: 2,
                                                    backgroundColor: "#fff",
                                                    transition: "all 0.18s ease",
                                                    "&:hover": { backgroundColor: "#fff" },
                                                }}
                                            >
                                                Source Code
                                            </Button>
                                        </Box>
                                    </Box>
                                </Box>
                            </Paper>
                        </Grid>
                    </Grid>

                </Box>
            </Grid>
        </Grid>

    );
}

    export default Project;